var _rect, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhoneIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_816_579",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "url(#pattern0)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_816_579)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#545A6D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_816_579",
    transform: "scale(0.03125)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_816_579",
    width: 32,
    height: 32,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAABHNCSVQICAgIfAhkiAAAAAlwSFlzAAARSQAAEUkBP8TncQAAABl0RVh0U29mdHdhcmUAd3d3Lmlua3NjYXBlLm9yZ5vuPBoAAAJxSURBVFiFtZcxaBRREIa/eW/WRBOEqGCtUQut0hl7kYCkEi0CGrQU1EIRrEQQFKwUG7uAQS0iiChCGu2UQERsVESLgEmwUFFQc7v7W+S8hONubw/2BoZt/nn/t4+d92aRRHMCAx78WjT/Es0fAQOtdFVkK/Nt0XwummtdPgOSngMAW4P5mybz1QzJdE8BgE3BfL6l+f8kTlQNEKhHwM8bjFAUxhUzC4WaLsMkYWZD0XwBGOhYIR1OlT6pCiAAROKhUuYAZqerMm8AEMJY+RLbWz2AtKe8P6+qBwArqV/O8trZXgB0DIN3mfyApKUqAbz+/N1B9zxVOi7VflZpDvUdMONFgeZPpnRSUuXmawC5PS3QRGCxF+YNgBq1OeBrG02SkOzrKYAkYbrfTpSh8V4BWP0iwsy2R/OPwGALXS3I9q9oZb5qgEYbSlqWuNFGl8h018w2Vg3QPA8MRvOlttdxiDd7PhFF4kTBTJBH4pGeAkgihninACKNxOMdF6Z/Z8AvBZJzwOauAID+YP66aCcCyZn2U45fjOZ/1+kX201TBW/QNxzNvxeNaB78MvVOqoNbDPF2Qc0ssGW9T6MNW4Wbj2M2w9qd0SJswUwPldtbTKeA0aKP3uB9qnRU0jegGKAOcQyzaVaP5KpiNlM6JinreB2nSh8gnQDyCgEOevCrUHIeSJVOI52sEiIXY6UB6hBTSEeBH5UQiJnVZ7cHB/07ovnLwh+YThmSKSAUtmExBIkHvx7Nsy7NawG/UOocKAfSNxxDvBXNf3U2j58dP9C8Rsc2LBNmNhRIJi0wgrQL2A1sEHwysw/k+b2M7LGkrLn2H4Ox1/nu8jXtAAAAAElFTkSuQmCC"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIcon);
export default __webpack_public_path__ + "static/media/phoneIcon.64eec92aecadf694aa91d67a33937d74.svg";
export { ForwardRef as ReactComponent };